import { useTranslation } from "react-i18next";
import { plantImage } from "../../../assets";
import StoreBadges from "../../../components/ui/StoreBadges";

interface PremiumSectionProps {
  className?: string;
}

function PremiumSection({ className }: PremiumSectionProps) {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <section id="premiumsection">
        <div className="premium-container flex items-center mx-auto w-[90%] sm:w-[80%] pb-120 py-20">
          <div className="premium-container text-left">
            <div className="premium-title text-4xl sm:text-6xl text-white">
              {t("premium.title")}
            </div>
            <div className="premium-desc mt-3 text-2xl text-white">
              {t("premium.description")}
            </div>
            <div className="pt-6">
              <StoreBadges />
            </div>
          </div>
          <div className="premium-img hidden sm:block">
            <img src={plantImage} alt="" className="h-[auto]" loading="lazy" />
          </div>
        </div>
      </section>
    </div>
  );
}

export default PremiumSection;
